export const categories = {
  'furnace-filters': 'Furnace filters',
  'humidifier-filters': 'Humidifier filters',
  'vacuum-bags': 'Vacuum Bags',
  'wifi-thermostats': 'WiFi Thermostats'
};
